import React from 'react';
import cx from 'classnames';
import styles from './styles.module';

const NavDivider = ({ label, className = null }) => {
  return <hr />;
};

export default NavDivider;
